// Shared accent/case-insensitive fuzzy matching used by the variable lists.

export const normalize = (value) =>
  value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

// True when `query` is a substring of `haystack`, or all of its characters
// appear in order (subsequence) — tolerant to small typos / omissions.
export const fuzzyMatch = (query, haystack) => {
  if (!query) return true;
  if (haystack.includes(query)) return true;

  let i = 0;
  for (const char of haystack) {
    if (char === query[i]) i += 1;
    if (i === query.length) return true;
  }
  return false;
};
